import { toTypedSchema } from '@vee-validate/zod'
import { object } from 'zod'
import { emailValidationSchema } from '.'
import { nameValidationSchema, phoneValidationSchema } from '@/schemas/common'

export const welcomeSchema = toTypedSchema(
  object({
    name: nameValidationSchema,
    email: emailValidationSchema,
  })
)

export const profileSchema = toTypedSchema(
  object({
    firstName: nameValidationSchema,
    lastName: nameValidationSchema,
    phone: phoneValidationSchema,
    email: emailValidationSchema,
  })
)

export const updatePhoneSchema = toTypedSchema(
  object({
    firstName: nameValidationSchema,
    lastName: nameValidationSchema,
    phone: phoneValidationSchema,
  })
)
